import { PERSON_ALREADY_ON_CLIENT } from '@nesso/client-contracts/client.errors';

import { ApiError } from '@/shared/api/http-client';

export function isPersonAlreadyOnClientError(error: unknown): boolean {
    return (
        error instanceof ApiError &&
        error.status === 409 &&
        error.message === PERSON_ALREADY_ON_CLIENT
    );
}
